import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { resetGuestData, selectInvitationGuestMembers } from '../store/slice/rsvp/slice';

function InvitationsLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let [searchParams] = useSearchParams();
  const { data } = useSelector(selectInvitationGuestMembers);

  useEffect(() => {
    if (!data.length && searchParams.has('step')) {
      dispatch(resetGuestData());
      const rsvpKey = searchParams.get('key');
      navigate({ search: 'key=' + rsvpKey }, { replace: true });
    }
  }, [data.length, dispatch, navigate, searchParams]);

  return <Outlet />;
}

export default InvitationsLayout;
